import { PropsWithChildren } from 'react';
import { useSearchParams } from 'react-router';

import Stack from '@/design_system/Stack';
import { getBrandLogoUrl } from '@/layouts/Brand/brandLogo';
import { useCurrentOrganization } from '@/services/auth';
import { createBEMClasses } from '@/utils/classname';

import './BrandCreationLayout.css';

const { block, element } = createBEMClasses('brand-creation-layout');

export const BrandCreationLayout = ({ children }: PropsWithChildren) => {
  return <div className={block()}>{children}</div>;
};

export const BrandCreationLayoutHeader = ({ children }: PropsWithChildren) => {
  const [organization] = useCurrentOrganization();
  const [searchParams] = useSearchParams();
  const requestId = searchParams.get('id');

  if (!organization) {
    return null;
  }

  return (
    <header className={element('header')}>
      <div
        className={element('header__brand-color')}
        style={{ background: organization.config.appStyle.headerColor }}
      />
      <div className={element('header__content')}>
        <Stack row gap="1rem" alignItems="center" justifyContent="space-between">
          <img
            src={getBrandLogoUrl({ organizationSlug: organization.slug, requestId })}
            alt=""
            style={{
              maxWidth: '5rem',
              maxHeight: '2.5rem',
            }}
          />
          {children}
        </Stack>
      </div>
    </header>
  );
};
